import React from 'react';
import {useTranslation} from "react-i18next";

function SpeakToExpertButton({maxWidth}) {
    const {t} = useTranslation();

    function handleSpeakToExpert() {
        window.open('https://nshift.com/contact-sales?utm_campaign=Misfits-Demo&utm_source=misfits-demo&utm_medium=demo-site&utm_term=speak-to-an-expert');
    }

    return (
        <div className={'delivery-options mt-20'}>
            <button className="btn-hover"
                    style={{marginTop: 20, backgroundColor: '#0215a3', maxWidth: maxWidth || '100%'}}
                    onClick={handleSpeakToExpert}>{t('speak_with_one_of_our_experts')}</button>
        </div>

    )
}

export {SpeakToExpertButton}
